import styled from 'styled-components'

export const Banner = styled.div<{ $win: boolean }>`
  border-radius: 8px;
  background-color: ${({ $win }) => ($win ? 'var(--primary100)' : 'var(--gray100)')};
  img {
    width: 100%;
    max-width: 100%;
  }
`
